/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UserFilterConfigColumn = (typeof UserFilterConfigColumn)[keyof typeof UserFilterConfigColumn];

export const UserFilterConfigColumn = {
  user: 'user',
} as const;
